/*
 * File: /src/store/modules/sms.js
 * Created Date: Sunday May 12th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 12th May 2019 10:42:50 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import smsService from '../../services/smsServices';

const state = {
  smsServices: undefined,
};

const getters = {
  getSmsServices: state => {
    return state.smsServices;
  },
  getSmsService: state => id => {
    for (const s of state.smsServices) {
      if (s.id == id) {
        return s;
      }
    }
    console.log('no service by that id.. yet');
    return state.smsServices[id];
  },
};
const actions = {
  fetchServices({ commit }) {
    if (state.smsServices == undefined) {
      return smsService
        .fetchServices()
        .then(r => {
          commit('setSmsServices', r.data);
        });
    }
  },
  unloadServices({ commit }) {
    commit('setSmsServices', undefined);
  },
  saveNewService({ commit }, smsService) {
    return new Promise((resolve, reject) => {
      const deliverable = {
        label: smsService.name,
        sequence: smsService.sequence
      };
      smsService
        .saveNewService(deliverable)
        .then(response => {
          commit('addSmsService', response.data);
          resolve({ success: 1, data: response.data });
        })
        .catch(e => {
          reject({ success: 0, error: e });
        });
    });
  },
};
const mutations = {
  setSmsServices(state, d) {
    state.smsServices = Object.assign([], d);
  },
  addSmsService(state, d) {
    const old = state.smsServices;
    old.push(d);
    state.smsServices = Object.assign([], old);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
